export default __webpack_public_path__ + "static/dx-tools-c458b418e9e557ddc017ba5f9e038118.png";